<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="text"
    item-value="qltyStdCd"
    :label="labelComputed"
    :disabled="disabled"
    :loading="loading"
    :required="required"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'QltyStandardInput',

  mixins: { APIUtils, Message },
  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      default: '',
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    labelComputed: {
      get() {
        return this.label ? this.label : this.$t('ELE0389')
      },
    },
  },

  async mounted() {
    this.loading = true

    try {
      let params = {}
      if (this.validOnly) {
        params.validOnly = true
      }

      const elements = await API.get('/master/qltyStd', params)
      elements.forEach((element) => {
        element['text'] = `${element['qltyStdCd']} : ${element['qltyStdName']}`
        this.items.push(element)
      })
      this.items = this.items.sort((a, b) => Number(a.qltyStdCd) - Number(b.qltyStdCd))
    } catch (error) {
      this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0389') })))
    } finally {
      this.loading = false
    }
  },
}
</script>
